import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import generalContent from 'assets/content/general.content.json';
import content from 'assets/content/product.content.json';

import NoImg from 'assets/images/noImg.png';

import style from './ColorOptionsMobileView.module.scss';

ColorOptionsMobileView.propTypes = {
    options: PropTypes.array,
    onClick: PropTypes.func.isRequired,
    selectedColor: PropTypes.object,
    images: PropTypes.array,
    editSpecification: PropTypes.bool,
    colorsGallery: PropTypes.array
};

function ColorOptionsMobileView({
    options,
    onClick,
    selectedColor,
    images,
    editSpecification,
    colorsGallery
}) {
    const [firstImage, setFirstImage] = useState(NoImg);
    const [secondImage, setSecondImage] = useState(NoImg);
    const [thirdImage, setThirdImage] = useState(NoImg);

    const getTheOptionForTheColor = (option, attr) => {
        switch (attr) {
            case 'hexcode':
                return colorsGallery.filter(g => g.id === option.value)[0].hex_code;
            case 'name':
            default:
                return colorsGallery.filter(g => g.id === option.value)[0].name;
        }
    };

    const getColorImages = () => {
        const colorImages = images && (images.find(i => i.id === selectedColor.value)?.images || []);

        setFirstImage(colorImages && colorImages[0] && (colorImages[0]?.url || NoImg));
        setSecondImage(colorImages && colorImages[0] && (colorImages[1]?.url || NoImg));
        setThirdImage(colorImages && colorImages[0] && (colorImages[2]?.url || NoImg));
    };

    useEffect(() => getColorImages());

    return (
        <div className={`${style.ColorOptionsWrapper}`}>
            <p className={style.ColorOptionsWrapper__title}>{generalContent?.COLOR}</p>
            <div className={style.ColorOptionsWrapper__images}>
                <div className={style.ColorOptionsWrapper__images__image__container}>
                    <img alt='' className={style.ColorOptionsWrapper__images__image__container__image} src={firstImage} />
                </div>
                <div className={style.ColorOptionsWrapper__images__image__container__vertical}>
                    <img alt='' className={style.ColorOptionsWrapper__images__image__container__vertical__image} src={secondImage} />
                    <img alt='' className={style.ColorOptionsWrapper__images__image__container__vertical__image} src={thirdImage} />
                </div>
            </div>
            <div className={style.ColorOptionsWrapper}>
                <div className={style.ColorOptionsWrapper__options}>
                    {options && options.map((option, i) =>
                        <div
                            key={i}
                            className={style.option}
                            onClick={() => onClick(option)}>
                            <div className={(options.length === 1 ? selectedColor.value === options[0].value : selectedColor.value === colorsGallery[i].id) ? style.option__title + ' ' + style.option__selected : style.option__title}>
                                <span className={selectedColor.value === option.value ? style.ColorOptionsWrapper__color__container__selected : style.ColorOptionsWrapper__color__container}><span className={style.ColorOptionsWrapper__color} style={{ background: getTheOptionForTheColor(option, 'hexcode') }} /></span>
                                <span className={selectedColor.value === option.value ? style.option__title__selected__span : style.option__title__span}>{getTheOptionForTheColor(option, 'name')}</span>
                            </div>
                            {typeof option.stock !== 'undefined' && option.stock === 0 && (
                                <div className={option.stock === 1 ? style.ColorOptionsWrapper__stock_status : style.ColorOptionsWrapper__out_stock_status}>
                                    {option.stock === 1 ? content?.CONTENT.IN_STOCK : content?.CONTENT.OUT_OF_STOCK}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>);
}

export default ColorOptionsMobileView;
